import { GET_STATUSES_SUCCESS_HANDLER } from "../actions/types";

export default (state = {}, action) => {
  switch (action.type) {
    case GET_STATUSES_SUCCESS_HANDLER:
      return action.payload;
    default:
      return state;
  }
};
